<template>
  <div>
    <div class="row dashboard-container">
      <div class="col-12">
        <full-calendar
          :event-sources="eventSources"
          :config="config"
          @event-selected="eventSelected"
        ></full-calendar>
        <!-- <order-detail
          :orderTracking="orderTracking"
          :orderSelected="orderSelected"
          :orderInfo="orderDetail"
          ref="form"
        ></order-detail> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// import "fullcalendar/dist/locale/vi";
// import OrderDetail from "@/pages/Order/OrderDetail.vue";

export default {
  components: {
    // OrderDetail,
  },
  data() {
    return {
      config: {
        defaultView: "month",
        locale: "vi",
      },
      eventSources: [
        {
          events(start, end, timezone, callback) {
            axios
              .get(`c-order/event`, {
                params: {
                  start: start.format("YYYY-MM-DD"),
                  end: end.format("YYYY-MM-DD"),
                  timezone: timezone,
                },
              })
              .then((response) => {
                callback(response.data);
              });
          },
          color: "yellow",
          textColor: "black",
        },
      ],
      orderDetail: {},
      orderTracking: {},
      orderSelected: {},
    };
  },
  methods: {
    eventSelected(event, jsEvent, view) {
      this.selectOrder(event.orderId);
    },
    selectOrder(id) {
      // let loader = this.$loading.show();
      Promise.all([this.getOrderDetail(id), this.getOrderHistoryDetail(id)])
        .then(([orderDetail, historyDetail]) => {
          this.orderDetail = orderDetail.data.data;
          this.orderTracking = historyDetail.data;
          this.orderSelected = historyDetail.data.order;
          this.$refs.form.openNav();
          // loader.hide();
        })
        .catch((error) => {
          // loader.hide();
        });
    },
    getOrderDetail(id) {
      return axios.get("c-order/detail-info?id=" + id);
    },
    getOrderHistoryDetail(id) {
      return axios.get("c-order/tracking?id=" + id);
    },
  },
};
</script>
<style lang="scss">
.dashboard-container {
  padding-top: 15px;
  padding-left: 15px;
  table {
    .fc-head {
      table {
        th {
          height: 36px;
          vertical-align: middle;
        }
      }
    }
  }
}
tr {
  font-size: 0.85em;
}

.fc-content {
  height: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #ffffff;
}

button {
  position: relative;
  text-align: center;
  cursor: pointer;
  outline: none;
  padding: 0;
  border: 0;
  margin: 4px;
  border-radius: 3px;
  background: white;
  border: 1px solid #9ac367;
  color: #9ac367;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-weight: 800;
}

.show-from-left-enter-active,
.show-from-left-leave-active {
  transition: transform 1s, opacity 0.7s;
}

.show-from-left-enter,
.show-from-left-leave-to {
  opacity: 0;
  transform: translate(-20px);
}

.show-from-right-enter-active,
.show-from-right-leave-active {
  transition: transform 1s, opacity 0.7s;
}

.show-from-right-enter,
.show-from-right-leave-to {
  opacity: 0;
  transform: translate(20px);
}

.pop-out-enter-active,
.pop-out-leave-active {
  transition: transform 1.5s, opacity 2s;
  transform-origin: center;
}

.pop-out-enter,
.pop-out-leave-to {
  opacity: 0;
  transform: rotate(720deg) translate(0, 120px);
}

div[data-popover="tooltip"] {
  background: #444;
  color: #f9f9f9;
  font-size: 12px;
  line-height: 1.5;
  margin: 5px;
}
.fc-toolbar {
  text-transform: capitalize;
}
</style>
